const normalize = value =>
  (value || '')
    .toString()
    .toLowerCase()
    .normalize('NFD')
    // Elimina acentos para que la búsqueda sea insensible a tildes
    .replace(/[\u0300-\u036f]/g, '')
    .trim();

const getLoadSearchFields = load => [
  load.from,
  load.fromProvince,
  load.to,
  load.toProvince,
  load.productType,
];

/**
 * Filtra las cargas por origen, destino o producto según el término buscado.
 * La coincidencia es parcial e insensible a mayúsculas y tildes.
 */
const filterLoads = (loads, searchTerm) => {
  if (!Array.isArray(loads)) {
    return [];
  }

  const term = normalize(searchTerm);
  if (!term) {
    return loads;
  }

  return loads.filter(load =>
    getLoadSearchFields(load).some(field => normalize(field).includes(term)),
  );
};

export default filterLoads;
